import type { CityConfig } from "../city-template/types";

export const spearfishConfig: CityConfig = {
  city: "Spearfish",
  state: "South Dakota",
  stateAbbr: "SD",
  slug: "spearfish",
  route: "/cities/spearfish",
  title: "Emergency Passport Spearfish, SD — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Spearfish, SD — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Spearfish residents, BHSU students, Black Hills outdoor professionals, and northern Hills travelers.",
  h1: "Emergency & Expedited Passport Services in Spearfish, SD",
  heroSubtitle: "BHSU study abroad program starting soon? Canadian Rockies outdoor adventure departing this weekend? Spearfish Canyon film festival trip to Europe in 2 weeks? We help Spearfish residents — from Black Hills State University students and faculty to outdoor recreation professionals to Northern Hills families — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Breathtaking%20view%20of%20Spearfish%20Canyon%20South%20Dakota%20with%20dramatic%20limestone%20canyon%20walls%20covered%20in%20ponderosa%20pine%20and%20aspen%20forests%2C%20Spearfish%20Creek%20winding%20through%20the%20valley%20floor%20with%20crystal%20clear%20rushing%20water%20over%20rocks%2C%20autumn%20golden%20hour%20sunlight%20illuminating%20the%20canyon%20walls%20in%20warm%20amber%20tones%2C%20scenic%20byway%20road%20curving%20through%20the%20dramatic%20landscape%20under%20a%20vast%20blue%20sky%20with%20scattered%20clouds&width=1800&height=700&seq=spearfish-hero-2026&orientation=landscape",
  heroImageAlt: "Spearfish Canyon Scenic Byway in the Black Hills of South Dakota",
  geoPosition: "44.4908;-103.8594",
  geoPlacename: "Spearfish, South Dakota",
  lastModified: "2026-06-15",
  regionalAgency: {
    name: "Denver Passport Agency",
    address: "3151 S Vaughn Way, Suite 600, Aurora, CO 80014",
    distance: "Located approximately 370 miles south of Spearfish via I-25 — appointments required, typically booked 2+ weeks out",
  },
  nearbyCitiesZips: [
    { name: "Spearfish", zips: "57783" },
    { name: "Belle Fourche", zips: "57717" },
    { name: "Sturgis", zips: "57785" },
    { name: "Lead", zips: "57754" },
    { name: "Deadwood", zips: "57732" },
    { name: "Whitewood", zips: "57793" },
    { name: "Sundance, WY", zips: "82729" },
    { name: "Newell", zips: "57760" },
    { name: "Vale", zips: "57788" },
    { name: "Nisland", zips: "57762" },
    { name: "Aladdin, WY", zips: "82710" },
    { name: "Hulett, WY", zips: "82720" },
    { name: "Fruitdale", zips: "57749" },
    { name: "Saint Onge", zips: "57779" },
  ],
  benefits: [
    { icon: "ri-flashlight-line", title: "24-Hour Emergency Processing", desc: "Reserved courier access to the Denver Passport Agency — as fast as 24 hours for Spearfish-area travelers with immediate departures." },
    { icon: "ri-graduation-cap-line", title: "BHSU Student & Faculty Support", desc: "Black Hills State University study abroad programs, faculty research travel, and international conferences — we understand university timelines." },
    { icon: "ri-landscape-line", title: "Black Hills Outdoor Recreation Hub", desc: "Spearfish Canyon, outdoor industry professionals, and international adventure tourism — we help outdoor recreation professionals travel abroad for industry events." },
    { icon: "ri-road-map-line", title: "Wyoming Border Access", desc: "Spearfish sits near the Wyoming border, providing access to Gillette (GCC) and Rapid City (RAP) airports — plus the Denver agency route via I-25." },
  ],
  internalLinks: [
    { name: "Expedited passport in Rapid City, SD", route: "/cities/rapid-city" },
    { name: "Fast passport services in Sioux Falls, SD", route: "/cities/sioux-falls" },
    { name: "Quick passport services in Mitchell, SD", route: "/cities/mitchell" },
    { name: "South Dakota passport services overview", route: "/states/south-dakota" },
    { name: "Wyoming passport services overview", route: "/states/wyoming" },
  ],
  fpcOfficeAddress: "3151 S Vaughn Way, Suite 600, Aurora, CO 80014",
  fpcOfficeNote: "Fast Passport Center serves Spearfish via secure registered courier with direct access to the Denver Passport Agency at 3151 S Vaughn Way, Suite 600, Aurora, CO 80014. Our registered couriers hand-deliver your documents — meaning you get faster results without the 370-mile drive. Spearfish residents can ship from any UPS Store, FedEx Office, or post office location across Lawrence County.",
  fpcOfficeDistance: "Serving Spearfish, Belle Fourche, Lead, Deadwood, Sturgis, and all Northern Black Hills communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Spearfish and the Northern Black Hills. From the BHSU campus to historic downtown Main Street, from Spearfish Canyon recreation areas to the surrounding ranch communities — we serve all of Lawrence County and adjacent areas. Our courier service eliminates the need to drive six hours to the Denver Passport Agency or wait for a post office appointment.",
  nearbyCitiesIntro: "We serve Spearfish and surrounding communities including Belle Fourche, Lead, Deadwood, Whitewood, and Sturgis. We also serve travelers departing from Rapid City Regional Airport (RAP) who need expedited passports.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Spearfish as simple as possible — with the efficiency and reliability BHSU students, outdoor recreation professionals, and Northern Hills families need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Spearfish travelers start online and ship documents overnight — no office visit required for most services.",
  mistakesIntro: "Spearfish travelers encounter unique passport issues — everything from BHSU study abroad deadlines to Canadian Rockies outdoor adventures to 6-month validity rules for European destinations. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Spearfish travelers — from BHSU Yellow Jackets to Spearfish Canyon guides to Northern Hills families — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Spearfish, SD? Here are the most common ones we hear from Lawrence County travelers.",
  statePageRoute: "/states/south-dakota",
  statePageName: "South Dakota",
  servicesIntro: "Whether you need a renewal before a Canadian Rockies adventure, an emergency passport for a BHSU study abroad program, or a first-time passport for a Spearfish Canyon-inspired trip to European mountain destinations — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://dps.sd.gov/driver-licensing",
  dmvLabel: "South Dakota DPS Driver Licensing — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "BHSU semester abroad starting in 3 days? Outdoor industry trade show in Canada this week? Our emergency courier service submits directly via reserved agency slots — as fast as 24 hours for Spearfish-area travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Spearfish residents renew fast — no agency visit required for most renewals. Perfect for BHSU faculty, Spearfish Canyon guides, and Lawrence County families.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Spearfish residents through every step — from BHSU freshmen to outdoor recreation professionals — with clear instructions for the nearest acceptance location.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your outdoor adventure or BHSU trip is not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions and checklists so your family trip to the Canadian Rockies or European Alps stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your travel documents match your reservations. Common for Spearfish residents after name changes.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for Spearfish outdoor industry professionals and BHSU researchers who travel abroad while their primary passport is in visa processing.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Spearfish-area travelers through the process so your international itinerary stays on track.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. We expedite passport card applications with the same courier service as book passports.",
      bullets: ["Wallet-size convenience", "Land and sea travel to nearby destinations", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Spearfish SD", description: "Urgent passport processing for Spearfish South Dakota travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Spearfish SD", description: "Fast passport renewal for Spearfish South Dakota residents with a previously-issued passport." },
    { name: "First-Time Passport Spearfish SD", description: "New passport application services for Spearfish South Dakota residents applying for their first passport." },
    { name: "Child Passport Spearfish SD", description: "Minor passport services for Spearfish South Dakota families with children under 16." },
    { name: "Name Change Passport Spearfish SD", description: "Passport name correction after marriage, divorce, or legal name changes for Spearfish residents." },
    { name: "Second Passport Spearfish SD", description: "Second passport services for Spearfish outdoor industry professionals and frequent international travelers." },
  ],
  testimonials: [
    {
      name: "Sarah M.",
      location: "BHSU Student, Spearfish",
      rating: 5,
      text: "I got into the semester abroad program in Spain with only 3 weeks to prepare. I did not have a passport. Fast Passport Center guided me through the whole process and it arrived with 5 days to spare. Dream trip, saved!",
      service: "First-Time Passport",
    },
    {
      name: "Dan R.",
      location: "Outdoor Guide, Spearfish",
      rating: 5,
      text: "I lead climbing expeditions internationally and my passport was expiring mid-season. They renewed it in under a week. Did not miss a single client booking.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "The Johnson Family",
      location: "Lawrence County",
      rating: 5,
      text: "We booked a Canadian Rockies family hiking trip. Two of us needed renewals and our son needed a first passport. Fast Passport Center handled all three applications smoothly. We hiked Banff together.",
      service: "Family Passports",
    },
    {
      name: "Prof. Emily W.",
      location: "BHSU Faculty, Spearfish",
      rating: 5,
      text: "I was presenting at an international geology conference in Norway. My passport expired and I only realized it 8 days before my flight. They pulled it off. I presented to a packed room.",
      service: "Emergency Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "spearfish-1",
      name: "Spearfish Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "120 Yankee St",
      city: "Spearfish",
      state: "SD",
      zip: "57783",
      phone: "(605) 642-4187",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Downtown Spearfish",
      website: "https://tools.usps.com/find-location.htm?location=1368582",
      websiteLabel: "USPS Location",
      notes: "Primary passport acceptance facility serving Spearfish and Lawrence County. Passport photos available. Appointment strongly recommended — limited walk-in capacity.",
      icon: "ri-mail-line",
    },
    {
      id: "spearfish-2",
      name: "Lawrence County Clerk of Courts",
      type: "County Clerk Passport Acceptance",
      address: "78 Sherman St",
      city: "Deadwood",
      state: "SD",
      zip: "57732",
      phone: "(605) 578-2040",
      hours: "Mon–Fri 8:00 AM – 5:00 PM",
      distance: "Deadwood — 15 miles southeast",
      website: "https://www.lawrence.sd.us/",
      websiteLabel: "Lawrence County",
      notes: "County clerk office offering passport acceptance services in historic Deadwood. Convenient for central Lawrence County residents. Call ahead to confirm clerk availability.",
      icon: "ri-government-line",
    },
    {
      id: "spearfish-3",
      name: "Sturgis Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1220 Main St",
      city: "Sturgis",
      state: "SD",
      zip: "57785",
      phone: "(605) 347-2960",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Sturgis — 20 miles southeast via I-90",
      website: "https://tools.usps.com/find-location.htm?location=1368578",
      websiteLabel: "USPS Location",
      notes: "Alternative acceptance facility in Sturgis. Passport photos available. Note: accessibility is limited during the annual Sturgis Motorcycle Rally (early August).",
      icon: "ri-mail-line",
    },
    {
      id: "spearfish-4",
      name: "Belle Fourche Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "510 Grant St",
      city: "Belle Fourche",
      state: "SD",
      zip: "57717",
      phone: "(605) 892-2531",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Belle Fourche — 11 miles north",
      website: "https://tools.usps.com/find-location.htm?location=1368575",
      websiteLabel: "USPS Location",
      notes: "Alternative acceptance facility for Butte County residents. Passport photos available. Less crowded than Spearfish post office — good option during peak times.",
      icon: "ri-mail-line",
    },
    {
      id: "spearfish-5",
      name: "Rapid City Downtown Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "500 East Blvd",
      city: "Rapid City",
      state: "SD",
      zip: "57701",
      phone: "(605) 348-2962",
      hours: "Mon–Fri 9:00 AM – 4:30 PM (appointment required)",
      distance: "Rapid City — 45 miles southeast via I-90",
      website: "https://tools.usps.com/find-location.htm?location=1368577",
      websiteLabel: "USPS Location",
      notes: "Larger acceptance facility with more appointment availability. Full photo services. Worth the drive for guaranteed service if Spearfish facilities are booked.",
      icon: "ri-mail-line",
    },
    {
      id: "spearfish-6",
      name: "Sundance Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "109 S 3rd St",
      city: "Sundance",
      state: "WY",
      zip: "82729",
      phone: "(307) 283-3927",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Sundance, WY — 30 miles west via I-90",
      website: "https://tools.usps.com/find-location.htm?location=1367924",
      websiteLabel: "USPS Location",
      notes: "Alternative acceptance facility across the border in Wyoming. Convenient for western Lawrence County residents. Call ahead to confirm hours and photo availability.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — typically booked 2+ weeks out, walk-ins not accepted", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive 370 miles to Denver Passport Agency", fpc: "Most Spearfish travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility with proof of travel", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure date", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle all shipping and logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "SD-Specific Guidance", agency: "Generic — no Northern Hills, BHSU, or outdoor recreation expertise", fpc: "Full BHSU/outdoor industry/Northern Hills knowledge built in" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "BHSU Study Abroad Rush",
      description: "BHSU students frequently apply for passports only weeks before study abroad departure. First-time passport applications require an acceptance facility visit plus processing time — start the process at least 8 weeks before departure.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Using DS-82 When DS-11 Is Required",
      description: "Spearfish applicants often attempt the simpler renewal form when their passport was issued at 15 or younger. A rejected form costs 1–2 weeks. We review before you submit.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards Violations",
      description: "Many Spearfish pharmacy and retail store photos fail State Department standards. We catch this in review before it causes a rejection.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Passport Card vs Book Confusion",
      description: "Outdoor recreation travelers heading to Canada often purchase a passport card thinking it works for air travel. Passport cards are for land/sea crossings only — not flights. We clarify requirements for your specific itinerary.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Sturgis Rally Season Disruption",
      description: "The annual Sturgis Motorcycle Rally (early August) fills local post offices and creates scheduling challenges throughout the Northern Hills. Plan passport processing around Rally week if possible.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order. Takes just a few minutes from your home, office, or BHSU dorm." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance tailored to your travel situation." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option. Most Spearfish clients ship from home or the UPS Store on North Main — no office visit needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you do not have to drive 370 miles to Denver or wait at a rural post office." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No guessing, no hoping an appointment opens up — just certainty." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Spearfish?", a: "We offer Spearfish-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. We review your documents before submission to catch errors that cause delays." },
    { q: "Do I need to visit an office in Spearfish?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (the Spearfish post office or the Lawrence County clerk in Deadwood), then ship documents overnight to our processing center. We handle the State Department submission and return your passport to your Spearfish address." },
    { q: "Where can I get passport acceptance in Spearfish?", a: "Spearfish has passport acceptance at the Main Post Office (120 Yankee St). Nearby options include post offices in Belle Fourche, Sturgis, Rapid City, and the Lawrence County Clerk in Deadwood." },
    { q: "Can BHSU students get expedited passports?", a: "Yes. Black Hills State University Yellow Jackets participating in study abroad, international research, or academic conferences can use our expedited courier service. We understand university timelines and can process first-time and renewal passports before program departure dates." },
    { q: "Can I fly internationally from Rapid City Regional Airport?", a: "Rapid City Regional Airport (RAP) is 45 miles southeast with daily connections to MSP, DEN, DFW, ORD, and SLC — all major international gateways. Spearfish residents can reach RAP in about 45 minutes and connect worldwide." },
    { q: "What documents do Spearfish applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent, and photos. We provide a Spearfish-specific checklist." },
    { q: "Can I get a passport photo in Spearfish?", a: "Yes — the Spearfish Main Post Office offers passport photos on-site. Additional photo locations include Lewis Drug, Walmart, Walgreens, and the BHSU campus store. Photos must be 2x2 inches, white background, no glasses, neutral expression." },
    { q: "How far is the nearest passport agency from Spearfish?", a: "The Denver Passport Agency (1961 Stout St, Denver, CO) is approximately 370 miles south of Spearfish via I-25. It requires appointments for life-or-death emergencies only. For travel within 3–14 days, our registered courier service is the fastest legally available channel." },
    { q: "How do I check my Spearfish passport status?", a: "Once submitted, we provide tracking at every stage. You can also check the State Department's online passport status system at travel.state.gov. Processing from Spearfish to final return shipping typically matches your chosen speed tier." },
    { q: "Does the Sturgis Rally affect passport services in Spearfish?", a: "The annual Sturgis Motorcycle Rally (early August) floods the entire Northern Hills region with 500,000+ visitors. Local post offices become extremely busy, and appointment availability shrinks. We strongly recommend completing any passport processing either well before or well after Rally week." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Spearfish Residents",
    intro: "Spearfish's location in the Northern Black Hills as a gateway to outdoor recreation and home to BHSU creates unique passport timing challenges. Here's what Spearfish travelers need to know.",
    cards: [
      {
        icon: "ri-graduation-cap-line",
        title: "Black Hills State University International Programs",
        subtitle: "BHSU study abroad, research conferences, and faculty exchanges",
        description: "BHSU's growing international programs send students to Europe, Asia, and Latin America each semester. Faculty present at international conferences in fields ranging from geology to outdoor education. The challenge: most BHSU students are first-time passport applicants who underestimate the multi-step process of first-time applications — acceptance facility visit plus processing time.",
        tip: "BHSU students: start your passport application the moment you commit to a study abroad program. First-time applications need 8+ weeks for safe processing.",
      },
      {
        icon: "ri-landscape-line",
        title: "Outdoor Recreation & Adventure Travel",
        subtitle: "From Spearfish Canyon to the Canadian Rockies and European Alps",
        description: "Spearfish attracts outdoor recreation professionals and enthusiasts who travel internationally for climbing, mountain biking, skiing, and fly fishing. Canadian Rockies adventures in Banff and Jasper are popular driving-distance international trips. European Alps expeditions require passports and sometimes visas. Many outdoor travelers use passport cards for Canada but forget they do not work for flights.",
        tip: "Outdoor travelers heading to Canada: a passport card works for driving across the border but not for flights. If there is any chance you will fly, get the full passport book.",
      },
      {
        icon: "ri-flight-takeoff-line",
        title: "RAP Airport — Your Black Hills Gateway",
        subtitle: "Rapid City Regional Airport connections worldwide",
        description: "Rapid City Regional Airport is a 45-minute drive from Spearfish with connections to five major hubs (MSP, DEN, DFW, ORD, SLC). This gives Spearfish travelers one-stop access to Europe, Asia, and the Americas. The drive from Spearfish to RAP is straightforward via I-90, but Spearfish travelers should factor in mountain weather during winter months.",
        tip: "During winter (November–March), allow extra driving time to RAP for potential snow on I-90. Leave Spearfish at least 2.5 hours before your flight.",
      },
      {
        icon: "ri-road-map-line",
        title: "Wyoming Border & Cross-State Travel",
        subtitle: "Sundance, Gillette, and northeastern Wyoming connections",
        description: "Spearfish sits just across the border from Sundance, Wyoming, and many Spearfish residents have ties to both states. Travelers heading south to Denver for the passport agency pass through eastern Wyoming. Gillette-Campbell County Airport (GCC) is an alternative regional airport about 90 miles west.",
        tip: "If RAP flights are limited, check Gillette-Campbell County Airport (GCC) and even Billings Logan International (BIL) as alternative gateways for international connections.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Spearfish & the Northern Black Hills Economy",
      description: "The Northern Black Hills economy blends education (BHSU), outdoor recreation, tourism, and agriculture. International travel demand is concentrated among BHSU affiliates, outdoor industry professionals, and families taking bucket-list trips to mountain destinations worldwide.",
    },
  },
  destinations: {
    title: "Where Spearfish Travelers Go — And Why Passports Get Urgent",
    intro: "Spearfish's unique mix of university travel, outdoor recreation, and Northern Hills tourism creates diverse passport needs. Here are the most common international destinations and the urgency patterns we see.",
    stats: [
      { stat: "35%", label: "of Spearfish expedited requests are BHSU study abroad or academic conference-related" },
      { stat: "2–4 Weeks", label: "average lead time for outdoor recreation professionals attending international trade shows" },
      { stat: "Aug", label: "month to avoid passport processing — Sturgis Rally floods the Northern Hills" },
      { stat: "370 Miles", label: "distance Spearfish residents avoid by using our courier instead of driving to the Denver agency" },
    ],
    destinations: [
      { name: "Canada", context: "Canadian Rockies adventures, outdoor industry trade shows, fishing and climbing trips", urgency: "Summer season May–September, passport card popular for land crossings", icon: "ri-map-pin-2-line" },
      { name: "Spain & Italy", context: "BHSU study abroad, art and geology programs, European climbing destinations", urgency: "Semester abroad deadlines — 8–12 week lead time ideal", icon: "ri-map-pin-2-line" },
      { name: "Switzerland & Austria", context: "BHSU geology conferences, European Alps climbing and skiing, mountain research", urgency: "Conference dates fixed — 4–8 week notice common", icon: "ri-map-pin-2-line" },
      { name: "Norway & Sweden", context: "BHSU environmental science research, Nordic outdoor recreation conferences", urgency: "Academic conference dates fixed months in advance", icon: "ri-map-pin-2-line" },
      { name: "Japan", context: "BHSU Asian studies programs, outdoor recreation technology conferences", urgency: "Long-lead planning but visa processes take additional time", icon: "ri-map-pin-2-line" },
      { name: "Mexico & Costa Rica", context: "Winter adventure travel, climbing and surfing trips, BHSU service learning", urgency: "Last-minute winter getaway bookings 3–4 weeks out", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other South Dakota Service Areas",
    crossLinksDesc: "We serve travelers across the Mount Rushmore State with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Rapid City", route: "/cities/rapid-city" },
      { name: "Sioux Falls", route: "/cities/sioux-falls" },
      { name: "Sturgis", route: "/cities/sturgis" },
    ],
  },
  photoLocations: [
    { name: "Spearfish Main Post Office", address: "120 Yankee St, Spearfish, SD 57783", hours: "Mon–Fri 9 AM – 4 PM" },
    { name: "Lewis Drug — Spearfish", address: "2310 Jackson Blvd, Spearfish, SD 57783", hours: "Mon–Fri 8 AM – 9 PM, Sat–Sun 9 AM – 6 PM" },
    { name: "Walmart Supercenter — Spearfish", address: "2825 1st Ave, Spearfish, SD 57783", hours: "Daily 7 AM – 11 PM" },
    { name: "Walgreens — Spearfish", address: "2421 Main St, Spearfish, SD 57783", hours: "Daily 8 AM – 10 PM" },
    { name: "UPS Store — Spearfish", address: "725 N Main St, Spearfish, SD 57783", hours: "Mon–Fri 8 AM – 6 PM, Sat 9 AM – 2 PM" },
    { name: "Belle Fourche Post Office", address: "510 Grant St, Belle Fourche, SD 57717", hours: "Mon–Fri 9 AM – 4 PM" },
    { name: "Rapid City Downtown Post Office", address: "500 East Blvd, Rapid City, SD 57701", hours: "Mon–Fri 9 AM – 4:30 PM" },
    { name: "FedEx Office — Rapid City", address: "2120 W Main St, Rapid City, SD 57702", hours: "Mon–Fri 7:30 AM – 9 PM, Sat 9 AM – 6 PM" },
  ],
  dmvLocations: [
    {
      name: "Spearfish DPS Driver License Exam Station",
      address: "719 N Main St, Spearfish, SD 57783",
      hours: "Mon–Fri, 7:00 AM – 5:30 PM",
      note: "Driver licenses, REAL ID, written and road tests. Appointment recommended.",
      featured: true,
    },
    {
      name: "Rapid City DPS Driver License Exam Station",
      address: "1301 E Catron Blvd, Rapid City, SD 57701",
      hours: "Mon–Fri, 7:00 AM – 5:30 PM",
      note: "Full-service DPS driver license office serving Pennington County. REAL ID available. Appointment strongly recommended.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "RAP",
      name: "Rapid City Regional Airport",
      distance: "About 45 miles southeast of Spearfish via I-90",
      address: "4550 Terminal Rd, Rapid City, SD 57703",
      note: "Primary airport for the Black Hills region. Daily nonstop connections to MSP, DEN, DFW, ORD, and SLC — all major international gateways. About a 45-minute drive from Spearfish.",
      flightUrl: "https://www.rapairport.com/",
      flightLabel: "RAP Airport Website",
      featured: true,
    },
    {
      code: "GCC",
      name: "Gillette-Campbell County Airport",
      distance: "About 90 miles west of Spearfish via I-90",
      address: "2000 Airport Rd, Gillette, WY 82716",
      note: "Alternative regional airport in Wyoming with connections to DEN and SLC. About a 90-minute drive from Spearfish through scenic northeastern Wyoming.",
      flightUrl: "https://www.gillettewy.gov/city-government/departments/airport",
      flightLabel: "GCC Airport Website",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the South Dakota Department of Health Vital Records. Online, mail, or in-person options available.",
      url: "https://doh.sd.gov/records/stillbirth.aspx",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through SD Department of Health Vital Records. Required for estate and legal matters.",
      url: "https://doh.sd.gov/records/stillbirth.aspx",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Lawrence County Register of Deeds. Certified copies available for name changes and legal purposes.",
      url: "https://www.lawrence.sd.us/departments/register-of-deeds",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Lawrence County Clerk of Courts. Required for name change passport corrections.",
      url: "https://www.lawrence.sd.us/departments/clerk-of-courts",
    },
  ],
};